export * from "ce/pages/common/PackageSearchItem";
import type { PackageSearchItemProps } from "ce/pages/common/PackageSearchItem";
import { DEFAULT_PACKAGE_ICON } from "ee/constants/PackageConstants";
import { Icon, Text } from "@appsmith/ads";
import React from "react";
import history from "utils/history";
import { BASE_PACKAGE_EDITOR_PATH } from "ee/constants/routes/packageRoutes";
import { SearchListItem } from "pages/common/SearchBar/WorkspaceSearchItems";

const PackageSearchItem = (props: PackageSearchItemProps) => {
  const { searchedPackages } = props;

  if (!searchedPackages || searchedPackages?.length === 0) return null;

  return (
    <div className="mb-2">
      <Text className="!mb-2 !block" kind="body-s">
        Packages
      </Text>
      {/* TODO: Fix this the next time the file is edited */}
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {searchedPackages.map((pkg: any) => (
        <SearchListItem
          key={pkg.id}
          onClick={() => history.push(`${BASE_PACKAGE_EDITOR_PATH}/${pkg.id}`)}
        >
          <Icon
            className="!mr-2"
            color="var(--ads-v2-color-fg)"
            name={pkg.icon || DEFAULT_PACKAGE_ICON}
            size="md"
          />
          <Text className="truncate" kind="body-m">
            {pkg.name}
          </Text>
        </SearchListItem>
      ))}
    </div>
  );
};

export default PackageSearchItem;
